import { generateRequest } from './index';
import { toQueryString } from '../../lib/utils/querystring';
import getFuelLogKey from '../../lib/utils/getFuelLogKey';

export const Action = {
  FuelLogs: {
    FetchFuelLogsPending: 'FetchFuelLogsPending',
    FetchFuelLogsCompleted: 'FetchFuelLogsCompleted',
    FetchFuelLogsFailed: 'FetchFuelLogsFailed',
    ExportFuelLogsPending: 'ExportFuelLogsPending',
    ExportFuelLogsCompleted: 'ExportFuelLogsCompleted',
    ExportFuelLogsFailed: 'ExportFuelLogsFailed',
    ResetFuelLogsExportResponse: 'ResetFuelLogsExportResponse',
  },
  FuelLogEntry: {
    AddFuelLogEntryPending: 'AddFuelLogEntryPending',
    AddFuelLogEntryCompleted: 'AddFuelLogEntryCompleted',
    AddFuelLogEntryFailed: 'AddFuelLogEntryFailed',
    UpdateFuelLogEntryPending: 'UpdateFuelLogEntryPending',
    UpdateFuelLogEntryCompleted: 'UpdateFuelLogEntryCompleted',
    UpdateFuelLogEntryFailed: 'UpdateFuelLogEntryFailed',
    DeleteFuelLogEntryPending: 'DeleteFuelLogEntryPending',
    DeleteFuelLogEntryCompleted: 'DeleteFuelLogEntryCompleted',
    DeleteFuelLogEntryFailed: 'DeleteFuelLogEntryFailed',
    ResetFuelLogResponse: 'ResetFuelLogResponse',
  },
};

export const fetchFuelLogs = (vehicleGuid, options) => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${vehicleGuid}/fuel-logs?${toQueryString(options)}`,
  types: [
    Action.FuelLogs.FetchFuelLogsPending,
    {
      type: Action.FuelLogs.FetchFuelLogsCompleted,
      meta: { fuelLogKey: getFuelLogKey(vehicleGuid, options.year) },
    },
    Action.FuelLogs.FetchFuelLogsFailed,
  ],
});

export const deleteFuelLogEntry = (fuelLogYear, vehicleGuid, fuelLogGuid) => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${vehicleGuid}/fuel-logs/${fuelLogGuid}`,
  method: 'DELETE',
  credentials: 'same-origin',
  types: [
    Action.FuelLogEntry.DeleteFuelLogEntryPending,
    {
      type: Action.FuelLogEntry.DeleteFuelLogEntryCompleted,
      meta: {
        fuelLogKey: getFuelLogKey(vehicleGuid, fuelLogYear),
        vehicleGuid,
        fuelLogGuid,
      },
    },
    Action.FuelLogEntry.DeleteFuelLogEntryFailed,
  ],
});

export const addFuelLogEntry = (fuelLogYear, vehicleGuid, fuelLog) => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${vehicleGuid}/fuel-logs`,
  method: 'POST',
  credentials: 'same-origin',
  body: fuelLog,
  types: [
    Action.FuelLogEntry.AddFuelLogEntryPending,
    {
      type: Action.FuelLogEntry.AddFuelLogEntryCompleted,
      meta: {
        fuelLogKey: getFuelLogKey(vehicleGuid, fuelLogYear),
        vehicleGuid,
      },
    },
    Action.FuelLogEntry.AddFuelLogEntryFailed,
  ],
});

export const updateFuelLogEntry = (fuelLogYear, vehicleGuid, fuelLog) => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${vehicleGuid}/fuel-logs/${fuelLog.guid}`,
  method: 'PATCH',
  credentials: 'same-origin',
  body: fuelLog,
  types: [
    Action.FuelLogEntry.UpdateFuelLogEntryPending,
    {
      type: Action.FuelLogEntry.UpdateFuelLogEntryCompleted,
      meta: {
        fuelLogKey: getFuelLogKey(vehicleGuid, fuelLogYear),
        vehicleGuid,
      },
    },
    Action.FuelLogEntry.UpdateFuelLogEntryFailed,
  ],
});

export const resetFuelLogResponse = () => ({
  type: Action.FuelLogEntry.ResetFuelLogResponse,
});

export const exportFuelLogs = (vehicleGuid, years) => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${vehicleGuid}/fuel-logs/export`,
  method: 'POST',
  body: {
    years,
  },
  credentials: 'same-origin',
  types: [
    Action.FuelLogs.ExportFuelLogsPending,
    Action.FuelLogs.ExportFuelLogsCompleted,
    Action.FuelLogs.ExportFuelLogsFailed,
  ],
});

export const resetFuelLogExportResponse = () => ({
  type: Action.FuelLogs.ResetFuelLogsExportResponse,
});
